import React, { FC } from 'react';
import ReactLoading from 'react-loading';

const Loading: FC<LoadingScreenProps> = ({ style, height, width, loadingType = 'spinningBubbles', color }) => {
  return (
    <div style={{ position: 'fixed', width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', zIndex: 10500, ...style }}>
      <ReactLoading type={loadingType as any} color={color || '#00BA99'} height={height} width={width} />
    </div>
  );
};

export interface LoadingScreenProps {
  style?: any;
  height?: any;
  width?: any;
  color?: string;
  loadingType?: "blank" | "balls" | "bars" | "bubbles" | "cubes" | "cylon" | "spin" | "spinningBubbles" | "spokes";
}

export default Loading;
